"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * PlumbingWorld-3.0
 * PlumbingWorld API
 *
 * Contact: jspencer@juliusspencer.co.nz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvoiceToJSON = exports.InvoiceFromJSONTyped = exports.InvoiceFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function InvoiceFromJSON(json) {
    return InvoiceFromJSONTyped(json, false);
}
exports.InvoiceFromJSON = InvoiceFromJSON;
function InvoiceFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'invoiceDate': !runtime_1.exists(json, 'invoiceDate') ? undefined : json['invoiceDate'],
        'invoiceNumber': !runtime_1.exists(json, 'invoiceNumber') ? undefined : json['invoiceNumber'],
        'salesOrderNumber': !runtime_1.exists(json, 'salesOrderNumber') ? undefined : json['salesOrderNumber'],
        'invoiceSuffixNumber': !runtime_1.exists(json, 'invoiceSuffixNumber') ? undefined : json['invoiceSuffixNumber'],
        'invoiceType': !runtime_1.exists(json, 'invoiceType') ? undefined : json['invoiceType'],
        'branchName': !runtime_1.exists(json, 'branchName') ? undefined : json['branchName'],
        'branchId': !runtime_1.exists(json, 'branchId') ? undefined : json['branchId'],
        'invoiceAmount': !runtime_1.exists(json, 'invoiceAmount') ? undefined : json['invoiceAmount'],
        'invoiceOrderNumber': !runtime_1.exists(json, 'invoiceOrderNumber') ? undefined : json['invoiceOrderNumber'],
        'invoiceExternalReference': !runtime_1.exists(json, 'invoiceExternalReference') ? undefined : json['invoiceExternalReference'],
        'invoiceComment': !runtime_1.exists(json, 'invoiceComment') ? undefined : json['invoiceComment'],
        'salesRep': !runtime_1.exists(json, 'salesRep') ? undefined : json['salesRep'],
        'userFullName': !runtime_1.exists(json, 'userFullName') ? undefined : json['userFullName'],
        'account': !runtime_1.exists(json, 'account') ? undefined : _1.ProstixAccountFromJSON(json['account']),
        'address1': !runtime_1.exists(json, 'address1') ? undefined : json['address1'],
        'address2': !runtime_1.exists(json, 'address2') ? undefined : json['address2'],
        'address3': !runtime_1.exists(json, 'address3') ? undefined : json['address3'],
        'address4': !runtime_1.exists(json, 'address4') ? undefined : json['address4'],
        'erp': !runtime_1.exists(json, 'erp') ? undefined : _1.ERPFromJSON(json['erp']),
        'invoiceItems': !runtime_1.exists(json, 'invoiceItems') ? undefined : (json['invoiceItems'].map(_1.InvoiceItemFromJSON)),
    };
}
exports.InvoiceFromJSONTyped = InvoiceFromJSONTyped;
function InvoiceToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'invoiceDate': value.invoiceDate,
        'invoiceNumber': value.invoiceNumber,
        'salesOrderNumber': value.salesOrderNumber,
        'invoiceSuffixNumber': value.invoiceSuffixNumber,
        'invoiceType': value.invoiceType,
        'branchName': value.branchName,
        'branchId': value.branchId,
        'invoiceAmount': value.invoiceAmount,
        'invoiceOrderNumber': value.invoiceOrderNumber,
        'invoiceExternalReference': value.invoiceExternalReference,
        'invoiceComment': value.invoiceComment,
        'salesRep': value.salesRep,
        'userFullName': value.userFullName,
        'account': _1.ProstixAccountToJSON(value.account),
        'address1': value.address1,
        'address2': value.address2,
        'address3': value.address3,
        'address4': value.address4,
        'erp': _1.ERPToJSON(value.erp),
        'invoiceItems': value.invoiceItems === undefined ? undefined : (value.invoiceItems.map(_1.InvoiceItemToJSON)),
    };
}
exports.InvoiceToJSON = InvoiceToJSON;
